import axios from "axios";
import appConfig from '../config/appConfig';

const axiosUnauth = axios.create({
  baseURL: `/`,
  headers: {
    "Content-Type": "application/json"
  },
});

const axiosAuth = axios.create({
  baseURL: `${appConfig.config['development']?.url}`,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer `,
  },
});

export {axiosUnauth, axiosAuth}
